/**
 * Luxury line-art SVG icons for each service tab.
 * Stroke-based, 36×36 viewBox, designed to render at 40px in the tab bar.
 * Gold accent stroke colour is applied via CSS class on the parent.
 */

export const IconServiceBuy = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Watch case — round */}
    <circle cx="18" cy="19" r="9.5" stroke="currentColor" strokeWidth="1.2" />
    {/* Crown / winding stem */}
    <rect x="27" y="17.5" width="3" height="3" rx="0.5" stroke="currentColor" strokeWidth="1.1" />
    {/* Strap top */}
    <path d="M14.5 9.5 L21.5 9.5 L21.5 9 Q18 7.5 14.5 9Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    {/* Strap bottom */}
    <path d="M14.5 28.5 L21.5 28.5 L21.5 29 Q18 30.5 14.5 29Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    {/* Lug lines top */}
    <line x1="15" y1="9.5" x2="15" y2="9.7" stroke="currentColor" strokeWidth="1.1" />
    <line x1="21" y1="9.5" x2="21" y2="9.7" stroke="currentColor" strokeWidth="1.1" />
    {/* Hour hand */}
    <line x1="18" y1="19" x2="18" y2="13.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    {/* Minute hand */}
    <line x1="18" y1="19" x2="22.5" y2="19" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    {/* Centre dot */}
    <circle cx="18" cy="19" r="1" fill="currentColor" />
    {/* Small purchase tag / star accent top-right */}
    <path d="M26 9 L27.2 7 L28.4 9 L26.6 10 L29 10.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconServiceSell = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Watch case */}
    <circle cx="16" cy="19" r="9" stroke="currentColor" strokeWidth="1.2" />
    {/* Strap top */}
    <path d="M12.5 10.2 L19.5 10.2 L19.5 9.5 Q16 8 12.5 9.5Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    {/* Strap bottom */}
    <path d="M12.5 27.8 L19.5 27.8 L19.5 28.5 Q16 30 12.5 28.5Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    {/* Crown */}
    <rect x="24.8" y="17.5" width="2.8" height="3" rx="0.5" stroke="currentColor" strokeWidth="1.1" />
    {/* Hour hand */}
    <line x1="16" y1="19" x2="16" y2="13.8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    {/* Minute hand */}
    <line x1="16" y1="19" x2="20" y2="19" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    {/* Centre dot */}
    <circle cx="16" cy="19" r="0.9" fill="currentColor" />
    {/* Rising arrow — "sell / upward value" */}
    <polyline points="24,14 27,10 30,14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="27" y1="10" x2="27" y2="20" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    {/* Small coin circles at base of arrow */}
    <circle cx="27" cy="22" r="1.8" stroke="currentColor" strokeWidth="1" />
    <line x1="27" y1="21" x2="27" y2="23" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
  </svg>
);

export const IconServiceTrade = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Left watch face */}
    <circle cx="11" cy="20" r="7" stroke="currentColor" strokeWidth="1.2" />
    {/* Left watch hour hand */}
    <line x1="11" y1="20" x2="11" y2="15.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <line x1="11" y1="20" x2="14.2" y2="20" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    <circle cx="11" cy="20" r="0.8" fill="currentColor" />
    {/* Right watch face */}
    <circle cx="25" cy="16" r="7" stroke="currentColor" strokeWidth="1.2" />
    {/* Right watch hour hand */}
    <line x1="25" y1="16" x2="25" y2="11.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <line x1="25" y1="16" x2="28.2" y2="16" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    <circle cx="25" cy="16" r="0.8" fill="currentColor" />
    {/* Swap arrows between the two watches */}
    {/* Arrow left-to-right (top arc) */}
    <path d="M16 14 Q18 10 22 14" stroke="currentColor" strokeWidth="1.1" fill="none" strokeLinecap="round" />
    <polyline points="21,12.5 22,14 20.5,15" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
    {/* Arrow right-to-left (bottom arc) */}
    <path d="M22 22 Q18 26 14 22" stroke="currentColor" strokeWidth="1.1" fill="none" strokeLinecap="round" />
    <polyline points="15,23.5 14,22 15.5,21" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconServiceConsignment = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Store shelf / display case outer rect */}
    <rect x="5" y="10" width="26" height="18" rx="1" stroke="currentColor" strokeWidth="1.2" />
    {/* Glass shelf divider */}
    <line x1="5" y1="20" x2="31" y2="20" stroke="currentColor" strokeWidth="0.9" strokeDasharray="2 1.5" />
    {/* Watch on upper shelf */}
    <circle cx="13" cy="15" r="3.5" stroke="currentColor" strokeWidth="1.1" />
    <line x1="13" y1="15" x2="13" y2="12.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    <line x1="13" y1="15" x2="15" y2="15" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <circle cx="13" cy="15" r="0.65" fill="currentColor" />
    {/* Watch on lower shelf */}
    <circle cx="23" cy="25" r="3.5" stroke="currentColor" strokeWidth="1.1" />
    <line x1="23" y1="25" x2="23" y2="22.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    <line x1="23" y1="25" x2="25" y2="25" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <circle cx="23" cy="25" r="0.65" fill="currentColor" />
    {/* Price tag on upper watch */}
    <path d="M17 11 L20 11 L20 14 L18.5 15.5 L17 14 Z" stroke="currentColor" strokeWidth="0.9" strokeLinejoin="round" />
    <circle cx="18.5" cy="12" r="0.5" fill="currentColor" />
    {/* Handshake line-art suggestion — two diagonal lines crossing like a contract signature */}
    <line x1="6" y1="8" x2="10" y2="8" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <line x1="26" y1="8" x2="30" y2="8" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <path d="M10 8 Q18 4 26 8" stroke="currentColor" strokeWidth="0.9" fill="none" strokeLinecap="round" />
  </svg>
);

export const IconServicePreorder = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Clipboard / order form */}
    <rect x="8" y="8" width="18" height="22" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
    {/* Clip at top */}
    <rect x="14" y="6" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.1" />
    {/* Lines on form */}
    <line x1="11" y1="15" x2="23" y2="15" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <line x1="11" y1="18.5" x2="20" y2="18.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <line x1="11" y1="22" x2="23" y2="22" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    {/* Mini watch icon within form — sourcing detail */}
    <circle cx="20.5" cy="26" r="2.5" stroke="currentColor" strokeWidth="1" />
    <line x1="20.5" y1="26" x2="20.5" y2="24.2" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    <circle cx="20.5" cy="26" r="0.55" fill="currentColor" />
    {/* Globe / network arc suggesting global sourcing */}
    <path d="M27 12 A5 5 0 1 1 27 22" stroke="currentColor" strokeWidth="1.1" fill="none" strokeLinecap="round" />
    <path d="M28.5 14 Q31 17 28.5 20" stroke="currentColor" strokeWidth="0.9" fill="none" strokeLinecap="round" />
    {/* Meridian line */}
    <line x1="27" y1="12" x2="27" y2="22" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" />
    {/* Equator arc on globe */}
    <path d="M24 17 Q27 18.5 30 17" stroke="currentColor" strokeWidth="0.8" fill="none" strokeLinecap="round" />
    {/* Down arrow — delivery */}
    <polyline points="27,22 27,28 24.5,25.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SERVICE_ICONS = {
  buy: IconServiceBuy,
  sell: IconServiceSell,
  trade: IconServiceTrade,
  consignment: IconServiceConsignment,
  preorder: IconServicePreorder,
};

export const ServiceIcon = ({ id, size }) => {
  const Icon = SERVICE_ICONS[id];
  return Icon ? <Icon size={size} /> : null;
};
